import { ifcConfigHttp } from './http';
import { BasketApiErrorModel, isApiError } from 'models/Errors';
import { errorToBasketErrorModel } from 'helpers';
import { IfcCalculatorConfigModel, IlpQuestionDescriptions } from 'models';

export class IfcConfigRepository {
    public async getIfcCalculatorConfig(totalPrice: number): Promise<IfcCalculatorConfigModel> {
        try {
            const response = await ifcConfigHttp.get<IfcCalculatorConfigModel>('/ifc-basket-configs/web', {
                params: {
                    timestamp: new Date().getTime(),
                    totalSum: totalPrice
                }
            });

            return response.data;
        } catch (error) {
            const errorSource = 'config.repository:getIfcCalculatorConfig';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }

    public async getIfcQuestionSet(): Promise<IlpQuestionDescriptions> {
        try {
            const response = await ifcConfigHttp.get<IlpQuestionDescriptions>('/ifc-questions', {
                params: {
                    timestamp: new Date().getTime()
                }
            });

            return response.data;
        } catch (error) {
            const errorSource = 'config.repository:getIfcQuestionSet';
            if (isApiError(error)) {
                throw new BasketApiErrorModel(error, errorSource);
            } else {
                throw errorToBasketErrorModel(error, errorSource);
            }
        }
    }
}

export const ifcConfig = new IfcConfigRepository();